var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5164 14.3999L10.9164 13.1999V8.18216M1.31641 11.9999C1.31641 6.69797 5.61447 2.3999 10.9164 2.3999C16.2183 2.3999 20.5164 6.69797 20.5164 11.9999M17.8829 10.9464L20.2829 13.3464L22.6829 10.9464",
    stroke: "#4D5975",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56646 14.7188C2.04668 16.3575 2.95236 17.8397 4.19138 19.0148C5.4304 20.1898 6.95855 21.0157 8.62036 21.4084C10.2822 21.8011 12.0184 21.7467 13.6523 21.2506C15.2862 20.7545 16.7596 19.8345 17.9226 18.5842",
    stroke: "#4D5975",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsHistory);
export default __webpack_public_path__ + "static/media/TransactionsHistory.ca7f23792dd57902489d49728326b934.svg";
export { ForwardRef as ReactComponent };